import { sva } from "../../styled-system/css";

export const menuStyles = sva({
  slots: ["content", "trigger", "indicator", "item", "triggerItem", "optionItem", "contextTrigger"],
  base: {
    content: {
      margin: "0",
      borderColor: "border",
      borderStyle: "solid",
      borderRadius: "4px",
      borderWidth: "1px",
      width: "160px",
      backgroundColor: "white",
      // padding: "5px",
      listStyleType: "none",
      zIndex: "var(--layer-index)",
    },
    trigger: { cursor: "pointer" },
    indicator: {
      "&[data-state='open']": { rotate: "90deg" },
    },
    item: {
      all: "unset",
      fontSize: "14px",
      lineHeight: 1,
      display: "flex",
      alignItems: "center",
      gap: "4px",
      cursor: "pointer",
      position: "relative",
      userSelect: "none",
      padding: "8px",
      "&[data-highlighted]": {
        outline: "none",
        backgroundColor: "rgb(0, 0, 0, 0.1)",
      },
      "&[data-disabled]": {
        opacity: 0.4,
      },
    },
    triggerItem: {
      all: "unset",
      fontSize: "14px",
      lineHeight: 1,
      color: "rgb(87, 70, 175)",
      display: "flex",
      alignItems: "center",
      gap: "4px",
      height: "25px",
      position: "relative",
      userSelect: "none",
      borderRadius: "3px",
      padding: "0px 5px",
      "&[data-highlighted]": {
        outline: "none",
        backgroundColor: "rgb(110, 86, 207)",
        color: "rgb(253, 252, 254)",
      },
      "&[data-disabled]": {
        opacity: 0.4,
      },
    },
    optionItem: {
      all: "unset",
      fontSize: "14px",
      lineHeight: 1,
      color: "rgb(87, 70, 175)",
      display: "flex",
      alignItems: "center",
      gap: "4px",
      height: "25px",
      position: "relative",
      userSelect: "none",
      borderRadius: "3px",
      padding: "0px 5px",
      "&[data-highlighted]": {
        outline: "none",
        backgroundColor: "rgb(110, 86, 207)",
        color: "rgb(253, 252, 254)",
      },
      "&[data-disabled]": {
        opacity: 0.4,
      },
    },
    contextTrigger: {
      border: "2px dashed blue",
      borderRadius: "4px",
      fontSize: "15px",
      paddingBlock: "40px",
      width: "300px",
      textAlign: "center",
    },
  },
});
